import React from 'react';
import { motion } from 'framer-motion';
import { Star, MapPin } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  city: string;
  comment: string;
  delay?: number;
}
export function TestimonialCard({
  name,
  city,
  comment,
  delay = 0
}: TestimonialCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} className="bg-white p-6 rounded-2xl shadow-lg border border-slate-100 hover:shadow-xl transition-shadow" data-id="element-109">
      <div className="flex gap-1 mb-4" data-id="element-110">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-111" />)}
      </div>
      <p className="text-slate-700 mb-4 leading-relaxed italic" data-id="element-112">"{comment}"</p>
      <div className="flex items-center justify-between pt-4 border-t border-slate-100" data-id="element-113">
        <div data-id="element-114">
          <p className="font-bold text-slate-900" data-id="element-115">{name}</p>
          <p className="text-sm text-slate-500 flex items-center gap-1" data-id="element-116">
            <MapPin className="w-3 h-3" data-id="element-117" />
            {city}
          </p>
        </div>
      </div>
    </motion.div>;
}